import BaseAPI from './base/base-api';

class DecFileAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'DeclareAPI';
	controllerName = 'file';

	/**
	 * Download file
	 */
	download(key) {
		let url = this.getAPIUrl() + '/download?key=' + key;
		let link = document.createElement('a');
		link.target = '_blank';
		link.href = url;
		link.click();
	}

	/**
	 * Download file
	 */
	print(key) {
		let url = this.getAPIUrl() + '/print?key=' + key;
		let link = document.createElement('a');
		link.target = '_blank';
		link.href = url;
		link.click();
	}
}

export default new DecFileAPI();
